import { Component, OnInit } from "@angular/core";
import { BaseService } from "./Services/Base.service";
import { Title } from "@angular/platform-browser";
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  lang: string;
  constructor(private base: BaseService, private title: Title) {
    this.lang = this.base.getLang();
  }
  ngOnInit() {
    if (this.lang == "en") {
      this.title.setTitle("Company Information Technology");
    } else if (this.lang == "ar") {
      this.title.setTitle("الشركة لتقانة المعلومات");
    }
  }
  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
    if (this.lang == "en") {
      this.title.setTitle("Company Information Technology");
    } else if (this.lang == "ar") {
      this.title.setTitle("الشركة لتقانة المعلومات");
    }
  }

  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.

    console.clear();
    console.info(
      "%c \n \n \nCompany Information Technology \nPlease don't copy or write here...! \n :) \n \n \n",
      " color: #25336d;font-size:1.7rem"
    );
  }
}
